import { Coffee, Sun, Moon } from 'lucide-react';

export const GROCERY_SERVICES = [
  {
    id: 'carrefour',
    name: 'Carrefour',
    logo: '🛒',
    color: 'bg-blue-600',
    searchUrl: (query) => `https://www.carrefour.fr/s?q=${encodeURIComponent(query)}`,
  },
  {
    id: 'auchan',
    name: 'Auchan',
    logo: '🏪',
    color: 'bg-red-600',
    searchUrl: (query) => `https://www.auchan.fr/recherche?text=${encodeURIComponent(query)}`,
  },
  {
    id: 'leclerc',
    name: 'E.Leclerc',
    logo: '🛍️',
    color: 'bg-blue-800',
    searchUrl: (query) => `https://www.e.leclerc/recherche?q=${encodeURIComponent(query)}`,
  },
  {
    id: 'amazon',
    name: 'Amazon Fresh',
    logo: '📦',
    color: 'bg-orange-500',
    searchUrl: (query) => `https://www.amazon.fr/s?k=${encodeURIComponent(query)}&i=amazonfresh`,
  },
  {
    id: 'ubereats',
    name: 'Uber Eats',
    logo: '🚗',
    color: 'bg-black',
    searchUrl: (query) => `https://www.ubereats.com/fr/search?q=${encodeURIComponent(query)}`,
  },
];

export const MEAL_SLOTS = [
  { id: 'petit_dejeuner', label: 'Petit-déjeuner', icon: Coffee },
  { id: 'dejeuner', label: 'Déjeuner', icon: Sun },
  { id: 'diner', label: 'Dîner', icon: Moon },
];

export const DAYS_OF_WEEK = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

export function getWeekDates(startDate) {
  const dates = [];
  const start = new Date(startDate);
  const day = start.getDay();
  const diff = start.getDate() - day + (day === 0 ? -6 : 1);
  start.setDate(diff);

  for (let i = 0; i < 7; i++) {
    const date = new Date(start);
    date.setDate(start.getDate() + i);
    dates.push(date.toISOString().split('T')[0]);
  }
  return dates;
}

export function formatDate(dateStr) {
  const date = new Date(dateStr);
  return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
}
